import { Box, Card, CardContent, Typography } from '@mui/material';
import { FC } from 'react';
import { AccountingPeriodsQuery, PeriodStatus } from '../../../../generated';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

interface PeriodSummaryCardsProps {
  periods: AccountingPeriodsQuery['accountingPeriods'];
  fiscalYear: number;
}

export const PeriodSummaryCards: FC<PeriodSummaryCardsProps> = ({ periods, fiscalYear }) => {
  const closedCount = periods.filter((p) => p.status === PeriodStatus.Closed).length;
  const openCount = 12 - closedCount;
  const lastClosedMonth = periods
    .filter((p) => p.status === PeriodStatus.Closed)
    .sort((a, b) => b.month - a.month)[0];

  const cards = [
    {
      title: 'Closed Periods',
      value: `${closedCount} / 12`,
      icon: <LockIcon sx={{ fontSize: 40 }} color="success" />,
      color: '#4caf50',
      bgColor: '#e8f5e9',
    },
    {
      title: 'Open Periods',
      value: `${openCount} / 12`,
      icon: <LockOpenIcon sx={{ fontSize: 40 }} color="primary" />,
      color: '#2196f3',
      bgColor: '#e3f2fd',
    },
    {
      title: 'Last Closed',
      value: lastClosedMonth ? `Month ${lastClosedMonth.month}` : 'None',
      subtitle: lastClosedMonth ? new Date(lastClosedMonth.closedAt!).toLocaleDateString() : '',
      color: '#ff9800',
      bgColor: '#fff3e0',
    },
  ];

  return (
    <Box display="flex" gap={2} mb={3}>
      {cards.map((card, index) => (
        <Card
          key={index}
          sx={{
            flex: 1,
            bgcolor: card.bgColor,
            borderLeft: `4px solid ${card.color}`,
          }}
        >
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {card.title}
                </Typography>
                <Typography variant="h4" fontWeight="bold" color={card.color}>
                  {card.value}
                </Typography>
                {card.subtitle && (
                  <Typography variant="caption" color="text.secondary">
                    {card.subtitle}
                  </Typography>
                )}
              </Box>
              {card.icon && <Box>{card.icon}</Box>}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};
